import { Component, Input, OnInit } from '@angular/core';
import { MedigiComponentCopyService } from '../../../medigi/medigi-component-copy.service';
import * as Aos from 'aos';
@Component({
  selector: 'app-large-card',
  templateUrl: './large-card.component.html',
  styleUrls: ['./large-card.component.scss'],
})
export class LargeCardComponent implements OnInit {
  @Input() cardType: string = '';
  @Input() cardInfo: any;
  @Input() pageLocation;
  cardIndex: number = 0;
  buttonCard;

  constructor(public medigiCopyService: MedigiComponentCopyService) {}

  ngOnInit() {
    Aos.init();
    if (this.cardType === 'button') {
      this.getButtonCardCopy();
    }
  }

  getButtonCardCopy() {
    if (this.pageLocation === 'manufacturer') {
      this.buttonCard =
        this.medigiCopyService.cards.largeCard.manufacturerPage.buttonCard[0];
    } else if (this.pageLocation === 'about-us') {
      this.buttonCard =
        this.medigiCopyService.cards.largeCard.aboutUsPage.buttonCard[0];
    } else if (this.pageLocation === 'pharmacies') {
      this.buttonCard =
        this.medigiCopyService.cards.largeCard.pharmacyPage.buttonCard[0];
    }
  }

  cardInteraction(index) {
    this.cardIndex = index;
  }
}
